
import React from "react";
import { Movie } from "@/types/movie";
import MovieCard from "../MovieCard";
import { useMovieContext } from "@/context";

interface MovieCardContainerProps {
  movie: Movie;
  currentTab?: string;
  viewMode?: "grid" | "list";
  onOpenMovieDetails: (tmdbId: number) => void;
  isSearchResult?: boolean;
}

const MovieCardContainer: React.FC<MovieCardContainerProps> = ({
  movie,
  currentTab,
  viewMode = "grid",
  onOpenMovieDetails,
  isSearchResult = false
}) => {
  // Ensure movie has valid tmdbId - this is now required
  if (!movie.tmdbId) {
    console.error('MovieCardContainer: Movie missing required tmdbId:', movie);
    return null;
  }

  // FIXED: Generate stable key that excludes favorite/planToWatch status to prevent remounts
  const dynamicKey = `tmdb-${movie.tmdbId}-${viewMode}-${currentTab}-${isSearchResult ? 'search' : 'regular'}`;

  return (
    <MovieCard
      key={dynamicKey}
      movie={movie}
      currentTab={currentTab}
      viewMode={viewMode}
      onOpenMovieDetails={onOpenMovieDetails}
      isSearchResult={isSearchResult}
      cardKey={dynamicKey}
    />
  );
};

export default MovieCardContainer;
